<template>
  <div
    v-show="isShowEl"
    class="global-search-entry"
    :class="{ sticky: sticky }"
    ref="globalSearchEntry"
  >
    <div class="btn" @click="mySearchAll()" :style="buttonStyle">
      {{buttonText ? buttonText : `在全局搜索“${searchingText}”`}}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    searchingText: {},
    buttonText: {
      type: String,
      default: ''
    },
    listLen: {
      type: Number,
      default: 0
    },
    listEl: {},
    buttonStyle: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      sticky: false
    }
  },
  computed: {
    ...mapGetters({
      isSearchAll: 'resources/isSearchAll',
    }),
    isShowEl () {
      return this.searchingText && !this.isSearchAll && this.listLen;
    },
  },
  watch: {
    listLen () {
      this.handleSticky();
    },
    searchingText () {
      this.handleSticky();
    },
    listEl () {
      this.handleSticky();
    }
  },
  created () {
    window.addEventListener("resize", this.onResize);
    this.$bus.on('globalSearchEntry.handleSticky', this.handleSticky);
  },
  beforeDestroy () {
    window.removeEventListener("resize", this.onResize);
    this.$bus.off('globalSearchEntry.handleSticky', this.handleSticky);
  },
  mounted () {
    this.handleSticky();
  },
  methods: {
    mySearchAll () {
      this.$store.commit('resources/setGlobalKeyword', this.searchingText);
      this.$store.commit('resources/setIsSearchAll', true);
    },
    handleSticky () {
      let listEl = this.listEl || this.$parent.$el;
      if (this.isSearchAll || !listEl) {
        return;
      }
      let oh = listEl.offsetHeight;
      let sh = listEl.scrollHeight;
      this.sticky = sh > oh;
    },
    onResize () {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.handleSticky();
      }, 220);
    }
  }
}
</script>

<style lang="scss" scoped>
.global-search-entry {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  cursor: pointer;
  background-color: #fff;
  & > .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 262px;
    height: 30px;
    background: #f2f3f7;
    opacity: 1;
    border-radius: 4px;
    padding-left: 10px;
    padding-right: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    &:hover {
      width: 262px;
      height: 30px;
      background: #ffffff;
      border: 1px solid #5778fb;
      opacity: 1;
      color: #5778fb;
    }
  }
  &.sticky {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 99999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resourcesArea/globalSearchEntry.vue